import React from 'react'
import BlueHeading from '../other/common/BlueHeading';
import Heading from '../common/ui/Heading';
import { WATCH_LIST } from '../../utils/other-component';

const Watch = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center justify-center flex-col">
          <BlueHeading text="Watch" />
          <Heading children="Watch & Be Inspired" />
          <p className="text-center max-w-[496px] mx-auto text-[#686868] text-base font-normal leading-[150%]">
            In the section below, you can watch all of Shri Deepak Ji’s
            interview videos, podcast episodes, and media features.
          </p>
          <div className="max-w-[1140px] mx-auto flex items-center gap-6 justify-between max-lg:flex-wrap pt-[50px] max-lg:pt-10 max-md:pt-6">
            {WATCH_LIST.map((obj, i) => (
              <div
                key={i}
                className="bg-[#241DB61A] border border-solid border-[#241DB64D] p-4 rounded-2xl w-full min-w-[558px] max-xl:min-w-[470px] max-lg:min-w-full h-[375px] max-xl:h-[400px]  max-lg:h-full"
              >
                <img
                  src={obj.img}
                  alt="Watch-here"
                  className="w-full max-w-[351px] mx-auto pt-[61px] max-lg:pt-10 max-lg:max-w-[240px]"
                />
                <h2 className="text-[#001A3D] font-bold text-[40px] max-lg:text-3xl max-sm:text-2xl leading-[130%]">{obj.title}</h2>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Watch